import CheckItem from '@allesauto/core/chekItem';
import SectionHeaderList from '@allesauto/core/sectionHeaderList';
import { HeaderListType } from '@allesauto/core/sectionHeaderList';
import { SchemaTypes, ShippingType } from '@allesauto/graphql/src/index';
import translate from '@allesauto/i18n';
import clsx from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import DealerAddress from '@/components/common/DealerAddress';

import {
  convertDeliveryTimeToString,
  mapAccessoryShippingType,
} from '@/features/Accessories/utils/valueMapperUtils';

export interface AccessoryDeliveryOptionsProps {
  accessory: SchemaTypes.Accessory;
  dealer: SchemaTypes.Dealer;
  priceDetails: SchemaTypes.AccessoryPriceDetails;
  selectedShipment?: SchemaTypes.Shipment;
  onShipmentChange?: (shipment: SchemaTypes.Shipment) => void;
  showAltHeadline?: boolean;
}

const AccessoryDeliveryOptions = ({
  accessory,
  dealer,
  priceDetails,
  selectedShipment,
  onShipmentChange,
  showAltHeadline,
}: AccessoryDeliveryOptionsProps) => {
  const intl = useIntl();

  const className = {
    productInfo: 'mb-30px md:mb-40px',
    subHeadline: 'font-weight-bold mb-20px',
    deliveryItem: 'mt-15px md:mt-20px',
    deliveryLocation: 'ml-30px',
  };

  return (
    <>
      <SectionHeaderList
        type={HeaderListType.LIST}
        image={
          accessory.images && accessory.images[0] ? [accessory.images[0]] : null
        }
        headline={accessory.title}
        fixedPrice={priceDetails.price}
        className={className.productInfo}
      />

      <p className={className.subHeadline}>
        {translate(
          intl,
          `ui.ACCESSORY_DELIVERY_OPTIONS.${
            showAltHeadline ? 'HEADLINE_ALT' : 'HEADLINE'
          }`
        )}
      </p>

      {priceDetails.shippingOptions.map((sh, i) => (
        <>
          <CheckItem
            key={sh.sku}
            type="radio"
            selected={selectedShipment?.sku === sh.sku}
            onClick={() => {
              if (onShipmentChange) {
                onShipmentChange(sh);
              }
            }}
            className={clsx(i !== 0 && className.deliveryItem)}
            title={translate(
              intl,
              `ui.ACCESSORY_DELIVERY_OPTIONS.OPTIONS.${sh.shippingType}`
            )}
            priceProps={
              sh.price
                ? {
                    price: sh.price,
                    hasFractionDigits: true,
                    priceTextKey: 'ui.PRICE.ADDITIONAL',
                  }
                : undefined
            }
            priceLabel={
              !sh.price ? translate(intl, 'ui.PRICE.FREE') : undefined
            }
            additionalChildren={
              sh.shippingType !== ShippingType.AccessoryDelivery ? (
                <div className="flex">
                  <DealerAddress dealer={dealer} />
                  <div className="ml-auto">
                    <div className="flex flex-col items-end">
                      <p>{mapAccessoryShippingType(sh.shippingType)}</p>
                      <p>
                        {convertDeliveryTimeToString(accessory.deliveryTime)}
                      </p>
                    </div>
                  </div>
                </div>
              ) : null
            }
            additionalChildrenClassName={className.deliveryLocation}
          />
        </>
      ))}
    </>
  );
};

export default AccessoryDeliveryOptions;
